import { render } from "./propagateDetails.vue?vue&type=template&id=17201a8c"
import script from "./propagateDetails.vue?vue&type=script&lang=js"
export * from "./propagateDetails.vue?vue&type=script&lang=js"

import "./propagateDetails.vue?vue&type=style&index=0&id=17201a8c&lang=scss"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__